export default __webpack_public_path__ + "static/media/prestige_logo.a496dca8.png";